import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Debtor } from 'src/app/_models';
import { ParameterData } from 'src/app/_helpers';
import { DebtorService, PreloadService } from 'src/app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentService, debtorPhonePrefix, debtorStatus, debtordocumenttype } from 'src/app/_enums';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { icons } from 'src/app/sharedcomp/constans/icons.constans';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-new-customer-company-create',
  templateUrl: './new-customer-create.component.html',
  styleUrls: ['./new-customer-create.component.css', '../../../../../assets/css/new-component-view.css', '../../../../../assets/css/new-buttons-theme.css'],
  animations: [
    trigger('animationDisplay', [
      state('visible-fields', style({ maxHeight: '500px' })),
      state('hide-fields', style({ maxHeight: '0' })),
      transition('visible-fields => hide-fields', animate('300ms ease-out')),
      transition('hide-fields => visible-fields', animate('300ms ease-in')),
    ]),
    trigger('iconAnimation', [
      state('visible-fields', style({
        transform: 'rotate(0deg)'
      })),
      state('hide-fields', style({
        transform: 'rotate(90deg)'
      })),
      transition('visible-fields => hide-fields, hide-fields => visible-fields', animate('500ms ease-in-out')),
    ]),
  ]
})
export class NewCustomerCompanyCreateComponent implements OnInit {

  public customer_public_id: string

  public debtorForm: FormGroup;
  public debPublicID: any;
  customerPuplic_key: any;
  isEmailEditControlDisabled = false;
  isalertVisiable = false;
  isalertExistVisiable = false;
  isalertErrorVisible = false;
  ddldbdocumenttype: any[];
  ddldebtorStatus: any[];
  ddldebtorPhonePrefix: any;
  statusresult: any;
  debname: any;
  symbolsValidator = "/^[a-zA-Z0-9\ ]+$/";

  extraFieldsState: 'visible-fields' | 'hide-fields' = 'hide-fields';
  isSidebarVisible: boolean = false;

  @Output() cancelCreation: EventEmitter<boolean> = new EventEmitter();

  images = [];
  preloadImages = ["../../../../../assets/new-icons/save-icon.svg"];
  icons: Record<string, Record<string, string>>;

  constructor(
    private parameterData: ParameterData
    , private debtorService: DebtorService
    , private _fb: FormBuilder
    , private router: Router
    , private route: ActivatedRoute
    , private documentType: debtordocumenttype
    , private _debtorStatus: debtorStatus
    , private _debtorPhonePrefix: debtorPhonePrefix
    , private preloadService: PreloadService
    , private spinnerService: Ng4LoadingSpinnerService,
    private documentService: DocumentService
  ) {
    this.icons = icons;
    this.isEmailEditControlDisabled = false;
    this.isalertVisiable = false;
    this.ddldebtorStatus = _debtorStatus.Status;
  }

  ngOnInit() {
    window.scroll(0, 0);

    let country = localStorage.getItem("country")
    this.ddldebtorPhonePrefix = this.documentService.getPrefixByIsoAlpha2(country);
    this.ddldbdocumenttype = this.documentService.getDocumentsByIsoAlpha2(country);

    let browserStorage1 = (localStorage.getItem('isCorporate') === 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');

      if (browserStorage == null || browserStorage === '' || browserStorage === undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customer_public_id = localStorage.getItem('companyId');
      }
    } else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

   this.images = this.preloadService.preloadImages(this.preloadImages, this.images)

    this.InitialSetup();
    // const toSelect_documenttype = this.ddldbdocumenttype.find(c => c.value === 'DNI');
    // this.debtorForm.get('document_type').setValue(toSelect_documenttype.value);

    const toSelect_status = this.ddldebtorStatus.find(c => c.value === 'ACTIVE');
    this.debtorForm.get('status').setValue(toSelect_status.value);
  }

  setCustomerStatus() {
    const statusControl = this.debtorForm.get('status').value;
    const currentValue = statusControl === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
    this.debtorForm.get('status').patchValue(currentValue);
  }

  closeCreateCustomerSidebar() {
    this.cancelCreation.emit(false);
  }

  toggleElement() {
    this.extraFieldsState = this.extraFieldsState === 'hide-fields' ? 'visible-fields' : 'hide-fields';
  }

  /**
   * this InitialSetup function is used to initialize the form controls
   */
  InitialSetup() {
    this.debtorForm = this._fb.group({
      id: new FormControl(0),
      external_id: new FormControl(""),
      name: new FormControl("", [Validators.required, Validators.maxLength(50), Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")]),
      email: new FormControl("", [Validators.required, Validators.email]),
      phone: new FormControl("", [Validators.required]),
      phone_prefix: new FormControl("Elija", [Validators.required, this.validatePrefixPhone.bind(this)]),
      document_id: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$")]),
      document_type: new FormControl("Elija", [Validators.required, this.validateDocumentType.bind(this)]),
      status: new FormControl("Activo"),
      address: this._fb.group({
        id: new FormControl(0),
        street: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
        county: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
        city: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
        state: new FormControl('', Validators.pattern("[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+")),
        created: new FormControl("0"),
        zip: new FormControl('" "')
      }),
      creditor: this._fb.group({
        public_id: new FormControl(this.customer_public_id)
      })
    });
  }

  validateDocumentType(control: FormControl): { [key: string]: any } | null {
    const selectedValue = control.value;
    if (selectedValue && selectedValue.toLowerCase() === 'elija') {
      return { invalidDocumentType: true };
    }
    return null;
  }

  validatePrefixPhone(control: FormControl): { [key: string]: any } | null {
    const selectedValue = control.value;
    if (selectedValue && selectedValue.toLowerCase() === 'elija') {
      return { invalidDocumentType: true };
    }
    return null;
  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
        return false;
      }
    }
    return true;
  }


  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (event.ctrlKey && event.keyCode == 83) {
      if (this.debtorForm.valid) {
        event.preventDefault();
        this.onsubmit(event, this.debtorForm);
      }
      else {
        event.preventDefault();
      }
    }
  }


  onsubmit(event, { value }: { value: Debtor }) {
    this.spinnerService.show();
    const phone = this.debtorForm.get('phone').value
    const prefix_phone = this.debtorForm.get('phone_prefix').value
    if (!(phone == undefined ||  prefix_phone== null)) {
      value.phone = prefix_phone + phone
    }

    const toget_documenttype = this.ddldbdocumenttype.find(c => c.short_name === value.document_type);
    value.document_type = toget_documenttype.short_name;

    const toget__status = this.ddldebtorStatus.find(c => c.value === value.status);
    value.status = toget__status.value;

    if (value.id === null) {
      value.id = 0;
    }
    if (value.id == 0) {


      this.debtorService.createDebtor(value)
        .subscribe(result => {
          if (result.status == "200") {
            if (result.body.Error == "500") {
              this.statusresult = result.body.Description;
              this.isalertExistVisiable = true;
              this.isalertVisiable = false;
              this.isalertErrorVisible = false;
            } else if (result.body.Error == "400") {
              this.statusresult = "Error actualizando información, revisar datos o reintente denuevo"
              this.isalertErrorVisible = true;
              this.isalertExistVisiable = false;
              this.isalertVisiable = false;
            } else if (result.body.email === value.email && result.body.external_id === value.external_id) {
                this.isalertExistVisiable = false;
                this.isalertVisiable = true;
                this.isalertErrorVisible = false;
              } else {
                this.statusresult = "Cliente con ese email o código ya existe";
                this.debPublicID = result.body.public_id;
                this.debname = result.body.name;
                this.isalertExistVisiable = true;
                this.isalertVisiable = false;
                this.isalertErrorVisible = false;
              }
          } else if (result.status == "201") {
            this.router.navigate([`/customers/${result.body.public_id}/view`]);
            this.isalertExistVisiable = false;
            this.isalertVisiable = true;
          }
          this.spinnerService.hide();

        }, error => {
          this.spinnerService.hide();
          this.statusresult = "Error actualizando información, revisar datos o reintente denuevo";
          this.isalertExistVisiable = false;
          this.isalertVisiable = false;
          this.isalertErrorVisible = true;
          console.log('Failed while trying to update the Debtor Details.' + error);
        });

    }
  }//end

  documentTypeChange(event: MatSelectChange) {
    const documentType = event.value;
    if (documentType === 'OTHER') {
      this.debtorForm.controls.document_id.setValue("");
      this.debtorForm.controls.document_id.setValidators([Validators.pattern("^[a-zA-Z0-9 \'\-]+$")])
    }
    else {
      this.debtorForm.controls.document_id.setValue("");
      this.debtorForm.controls.document_id.setValidators([Validators.required, Validators.pattern("^[0-9]*$")])
    }
  }
}
